<template>
  <table>
    <thead>
      <tr>
        <th>{{ $t('paymentSelection.combiDealDiscountOverview.column.product') }}</th>
        <th>{{ $t('paymentSelection.combiDealDiscountOverview.column.discount') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(cartProductItem, key) in cartProductItems"
          v-if="cartProductItem.combiDealDiscountAmount.amount < 0"
          :key="key">
        <td>{{ cartProductItem.productTitle }}</td>
        <td>{{ $n(cartProductItem.combiDealDiscountAmount.amount * -1, 'currency') }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'CombiDealDiscountOverview',
  props: {
    cartProductItems: {
      type: Array,
      default: () => []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/payment-selection/CombiDealDiscountOverview.vue